export default "__VITE_ASSET__d563c13e__"